import React from "react";
import { StaticQuery, graphql } from "gatsby";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import favicon from '../media/favicon-32x32.png'

function SEO(props) {
  let isEn = false
  if(typeof document !== 'undefined') {
    isEn = document.location.href.includes('/en/')
  }
  const { description, meta, keywords, title } = props;
  // const description = isEn ? props.descriptionEn : props.description
  const lang = isEn ? props.langEn : props.lang
  // const meta = isEn ? props.metaEn : props.meta
  // const keywords = isEn ? props.keywordsEn : props.keywords
  // const title = isEn ? props.titleEn : props.title
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription = description || (data.site && data.site.description) || "";
        const siteTitle = (data.site && data.site.title) || "";
        const siteAuthor = (data.site && data.site.author && data.site.author.name) || "";
        console.log(data, props)
        return (
          <Helmet
            htmlAttributes={{ lang }}
            title={title}
            titleTemplate={title === siteTitle ? "%s" : `%s | ${siteTitle}`}
            meta={[
              {
                name: "description",
                content: metaDescription
              },
              {
                property: "og:title",
                content: title
              },
              {
                property: "og:description",
                content: metaDescription
              },
              {
                property: "og:type",
                content: "website"
              },
              {
                name: "twitter:card",
                content: "summary"
              },
              {
                name: "twitter:creator",
                content: siteAuthor
              },
              {
                name: "twitter:title",
                content: title
              },
              {
                name: "twitter:description",
                content: metaDescription
              }
            ]
              .concat(
                keywords && keywords.length > 0
                  ? {
                      name: "keywords",
                      content: keywords.join(", ")
                    }
                  : []
              )
              .concat(meta)}
          ><link rel="icon" type="image/png" href={favicon} /></Helmet>
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: "ru",
  meta: [],
  keywords: []
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site: sanitySiteSettings(_id: { eq: "siteSettings" }) {
      title
      description
      keywords
    }
  }
`;
